import React from 'react';
import { siteContent } from '../data/content';
import './About/About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about__content">
          <div className="about__image">
            <img 
              src="/images/about/about.bmp" 
              alt="Valérie Perez avec le livre Destins de Femmes" 
              className="about__photo"
            />
          </div>
          
          <div className="about__text">
            <h2 className="about__title">{siteContent.about.title}</h2>
            
            <div className="about__description">
              {siteContent.about.content.map((paragraph, index) => (
                <p key={index} className="about__paragraph">
                  {paragraph}
                </p>
              ))}
            </div>
            
            <div className="about__awards">
              <h3 className="about__awards-title">Reconnaissances</h3>
              <div className="about__awards-list">
                {siteContent.about.awards.map((award, index) => (
                  <div key={index} className="about__award">
                    <div className="about__award-icon">🏆</div>
                    <span className="about__award-text">{award}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

